// extracted by mini-css-extract-plugin
export default {"button":"styles_button__1wPz5","outlined":"styles_outlined__HFp6f","white":"styles_white__WgnaH"};